import TextareaSystem from './TextareaSystem';
import './TextareaSystem.scss';

export default TextareaSystem;
